export default {
    Admin: "1",
    Verifikator: "2",
    Sponzor: "3",
    JLSPaid: "4",
    JLSTrial: "5",
    GospodarskiSubjekti: "6",
    Stanovnici: "7"
}